interface EnvConfig {
  apiUrl: string;
  pusherKey: string;
  pusherCluster: string;
  appEnv: string;
  /**
   * Segment browser write key (AS-1832). When unset the analytics layer
   * no-ops — useful in local dev where we don't want to dirty Segment
   * with developer noise.
   */
  segmentWriteKey: string;
  modelBenchmarkEnabled: boolean;
  talentHubOrigin: string;
}

export const config: EnvConfig = {
  // In local dev, proxy routes through nginx to screener backend
  // URL pattern: http://localhost/screener/...
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost/screener",
  pusherKey: import.meta.env.VITE_PUSHER_KEY || "",
  pusherCluster: import.meta.env.VITE_PUSHER_CLUSTER || "us2",
  appEnv: import.meta.env.VITE_APP_ENV || "development",
  segmentWriteKey: import.meta.env.VITE_SEGMENT_WRITE_KEY || "",
  modelBenchmarkEnabled:
    import.meta.env.DEV ||
    import.meta.env.VITE_MODEL_BENCHMARK_ENABLED === "true",
  talentHubOrigin: import.meta.env.VITE_TALENTHUB_ORIGIN || "",
};
